'use client';
import { Navigation } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import EcoImg from 'eco-design/base/eco-img';
import './index.scss';

const NavChevron = (
    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden>
        <path
            d="M6.56019 12.5836L1.05065 7.07409C0.871663 6.8951 0.871663 6.6049 1.05065 6.42591L6.56019 0.916369"
            stroke="currentColor"
            strokeWidth="1.83333"
            strokeLinecap="round"
        />
    </svg>
);

export default function IndexClient({ list, prefixCls, id }: { list: any[]; prefixCls: string; id: string }) {
    const showNav = list.length > 1;
    const navScope = `#editor-${id}`;

    console.log('kol-list', list);
    return (
        <div className={`${prefixCls}-items ${prefixCls}-items-${id}`}>
            <div className={`${prefixCls}-carousel`}>
                {showNav && (
                    <button type="button" className={`${prefixCls}-nav-prev swiper-button-prev`} aria-label="Vorige">
                        {NavChevron}
                    </button>
                )}
                <Swiper
                    className={`${prefixCls}-swiper`}
                    modules={showNav ? [Navigation] : []}
                    navigation={
                        showNav
                            ? {
                                  prevEl: `${navScope} .${prefixCls}-nav-prev`,
                                  nextEl: `${navScope} .${prefixCls}-nav-next`,
                              }
                            : undefined
                    }
                    spaceBetween={12}
                    slidesPerView="auto"
                >
                    {list.map((item: any, i: number) => {
                        const { pc, h5, title, titleColor } = item;
                        return (
                            <SwiperSlide
                                className={`${prefixCls}-swiper-slide ${prefixCls}-item`}
                                key={i}
                                onClick={() => {
                                    window.open(item.linkURL, '_blank');
                                }}
                            >
                                <EcoImg className={`${prefixCls}-item-img`} pc={pc} pad={pc} h5={h5 || pc} alt={title} />
                                <div className={`${prefixCls}-item-info`}>
                                    <p className={`${prefixCls}-item-text`} style={{ color: titleColor }}>
                                        {title}
                                    </p>
                                </div>
                            </SwiperSlide>
                        );
                    })}
                </Swiper>
                {showNav && (
                    <button type="button" className={`${prefixCls}-nav-next swiper-button-next`} aria-label="Volgende">
                        {NavChevron}
                    </button>
                )}
            </div>
        </div>
    );
}
